import { type RefObject } from 'react';

import {
  ROOM_COLUMN_WIDTH_PX,
  TIMELINE_HEADER_HEIGHT_PX,
  TIMELINE_HOUR_WIDTH_PX,
  TIMELINE_WIDTH_PX,
} from '../lib/timeline';
import { TimeAxisHeader } from './time-axis-header';

interface RoomOverviewTimelineHeaderProps {
  headerScrollRef: RefObject<HTMLDivElement | null>;
  verticalScrollbarWidth?: number;
}

export function RoomOverviewTimelineHeader({
  headerScrollRef,
  verticalScrollbarWidth = 0,
}: RoomOverviewTimelineHeaderProps) {
  return (
    <div
      className='flex shrink-0 border-b border-border bg-background'
      style={{ height: TIMELINE_HEADER_HEIGHT_PX }}
    >
      <div
        className='z-20 shrink-0 border-b border-r-2 border-border bg-background'
        style={{
          width: ROOM_COLUMN_WIDTH_PX,
          height: TIMELINE_HEADER_HEIGHT_PX,
        }}
      />
      <div className='flex h-full min-w-0 flex-1'>
        <div
          ref={headerScrollRef as RefObject<HTMLDivElement>}
          className='h-full min-w-0 flex-1 overflow-hidden'
          aria-hidden
        >
          <TimeAxisHeader
            hourWidthPx={TIMELINE_HOUR_WIDTH_PX}
            timelineWidthPx={TIMELINE_WIDTH_PX}
          />
        </div>
        {verticalScrollbarWidth > 0 && (
          <div
            className='shrink-0'
            style={{ width: verticalScrollbarWidth }}
            aria-hidden
          />
        )}
      </div>
    </div>
  );
}
